import React, { FC, useId, useRef } from 'react'

import { CheckmarkIcon, IconSizes, IconWeight } from '@inno-ui/icons'
import cn from 'classnames'

import styles from './AuthCheckbox.module.scss'
import { AuthCheckboxProps } from './AuthCheckbox.types'

export const AuthCheckbox: FC<AuthCheckboxProps> = ({
  labelClassName,
  label,
  checked,
  onChange,
  onBlur,
  error
}) => {
  const checkboxId = useId()
  const inputRef = useRef<HTMLInputElement>(null)
  const hasError = Boolean(error)

  return (
    <div className={cn(styles.authCheckbox, { [styles.hasError]: hasError })}>
      <div className={styles.checkboxGroup}>
        <input
          ref={inputRef}
          type='checkbox'
          id={checkboxId}
          className={styles.input}
          checked={checked}
          onChange={onChange}
          onBlur={onBlur}
        />
        <button
          type='button'
          className={cn(styles.checkbox, {
            [styles.checked]: checked
          })}
          onClick={() => inputRef.current?.click()}
        >
          <CheckmarkIcon
            size={IconSizes.Size12}
            weight={IconWeight.Bold}
            color='var(--white)'
            className={styles.checkmark}
          />
        </button>
        <label
          htmlFor={checkboxId}
          className={cn(styles.label, labelClassName)}
        >
          {label}
        </label>
      </div>
    </div>
  )
}
